import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'


const _hoisted_1 = { class: "genericPadding hasHeader hasFooter bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "fs_10 grey d-block ln_12" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_7 = { class: "footerButtonContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.back()))
      }, [
        _hoisted_3
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_localized_text, {
          class: "fs_12 greyBlue d-block ln_12",
          localizedKey: "app_creaunnuovoevento",
          text: "Crea un nuovo evento"
        }),
        _createVNode("span", _hoisted_5, "Step " + _toDisplayString(_ctx.currentStep) + "/3", 1)
      ]),
      _hoisted_6
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.step))),
    _createVNode("div", _hoisted_7, [
      _createVNode("button", {
        type: "button",
        class: "genericButton bgGreyBlue w-100",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.next())),
        disabled: !_ctx.canNext
      }, [
        _createVNode(_component_localized_text, {
          class: "fs_13 white",
          localizedKey: "app_avanti",
          text: "Avanti"
        })
      ], 8, ["disabled"])
    ])
  ]))
}